import React, { Fragment, useContext } from "react";

import { EligibilityContext } from "../../contexts/EligibilityContext";
import Notifications from "./resources/Notifications";
import ExternalFunds from "./resources/ExternalFunds";
import Email from "./resources/Email";

import { notDiseaseFund } from "../../helpers/fund";

const Resources = (props) => {
  const context = useContext(EligibilityContext);

  return (
    <div className="f-scale-body u-richtext">
      {props.status === "closed" && (
        <Fragment>
          <p className="f-h3 u-mb2" style={{ marginTop: 0 }}>
            The fund for {context.state.diseaseFund.name} is closed.
          </p>
          <p class="eligibility-wizard-fund-closed-last-p">
            This fund is currently closed, but eligible patients can join the wait list. Visit{" "}
            <a
              /* this id is used for GA */
              id="ga-wizardFundPageLink"
              href={context.state.diseaseFund.permalink}
            >
            the fund page
            </a>{" "}
            to sign up for the wait list or contact us at the number below.
          </p>

          {context.state.diseaseFund.showWaitList && (
            <Fragment>
              {notDiseaseFund(context.state.diseaseFund.groupId) &&
                context.state.role === "patient" && (
                  <Fragment>
                    <Notifications />
                    <hr />
                  </Fragment>
                )}
              {!notDiseaseFund(context.state.diseaseFund.groupId) && (
                <Fragment>
                  <Notifications />
                  <hr />
                </Fragment>
              )}
            </Fragment>
          )}
        </Fragment>
      )}

      {props.status === "notEligible" && (
        <p className="f-h3 u-mb2" style={{ marginTop: 0 }}>
          {context.state.role === "patient" && (
            <Fragment>
              You are not eligible for this fund, but we still may be able to
              help.
            </Fragment>
          )}
          {(context.state.role === "provider" ||
            context.state.role === "pharmacy") && (
            <Fragment>
              The patient is not eligible for this fund, but we still may be
              able to help.
            </Fragment>
          )}
        </p>
      )}

      {props.status === "waitListOnly" && (
        <Fragment>
          <p className="f-h3 u-mb2" style={{ marginTop: 0 }}>
            This fund is accepting applications on our wait list only.
          </p>
          <p>
            If you signed up for this disease's wait list, you received an email
            from PAN with the link to apply. If not, please check back soon to
            see if the fund is open to sign up for the wait list.
          </p>
        </Fragment>
      )}

      {/* <ExternalFunds /> */}

      {context.state.role === "patient" &&
        context.state.supportPrograms.length > 0 && (
          <Fragment>
            <hr />
            <Email />
          </Fragment>
        )}
      
      {props.status !== "closed" && (
        <hr />
      )}

      {props.status !== "closed" && (
        <p className="u-mb2">
          If you still need help, visit{" "}
          <a
            /* this id is used for GA */
            id="ga-wizardFundPageLink"
            href={context.state.diseaseFund.permalink}
          >
            this fund's page
          </a>{" "}
          to learn more about its eligibility requirements or contact us using the number below.
        </p>
      )}
    </div>
  );
};

export default Resources;
